import React, {useEffect, useState} from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Select, MenuItem, InputLabel, FormControl, Alert } from '@mui/material';
import { AdSpaceOwnerPackageInterface } from '../../../interfaces/interfaces';

interface Props {
  open: boolean;
  packageToUpdate: AdSpaceOwnerPackageInterface | null;
  setPackageToUpdate: React.Dispatch<React.SetStateAction<AdSpaceOwnerPackageInterface | null>>;
  onClose: () => void;
  onSave: () => void;
  updateError?: string | null;
  updateSuccess?: string | null;
}

export const AdSpaceOwnerPackagesUpdateDialog: React.FC<Props> = ({
  open,
  packageToUpdate,
  setPackageToUpdate,
  onClose,
  onSave,
  updateError,
  updateSuccess,
}) => {

  const [adSpacesInput, setAdSpacesInput] = useState('');

  const handleAdSpacesInputSave = () => {
  try {
    const arr = JSON.parse(adSpacesInput);
    if (Array.isArray(arr)) {
      setPackageToUpdate(p => p ? { ...p, adSpacesInThisPackage: arr } : p);
    }
  } catch {
    // Optionally show an error or ignore invalid JSON
    alert('Invalid JSON array in Ad Space IDs field');
  }
};

  useEffect(() => {
    setAdSpacesInput(
      Array.isArray(packageToUpdate?.adSpacesInThisPackage)
        ? JSON.stringify(packageToUpdate?.adSpacesInThisPackage)
        : '[]'
    );
  }, [packageToUpdate]);

  return (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>Update Ad Space Owner Package</DialogTitle>
    <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
      {updateError && <Alert severity="error">{updateError}</Alert>}
      {updateSuccess && <Alert severity="success">{updateSuccess}</Alert>}
      <TextField
        label="Total Price"
        type="number"
        value={packageToUpdate?.packageTotalPrice ?? ''}
        onChange={e => setPackageToUpdate(p => p ? { ...p, packageTotalPrice: Number(e.target.value) } : p)}
        fullWidth
        margin="dense"
        required
      />
      <TextField
        label="User ID"
        type="number"
        value={packageToUpdate?.userId ?? ''}
        onChange={e => setPackageToUpdate(p => p ? { ...p, userId: Number(e.target.value) } : p)}
        fullWidth
        margin="dense"
        required
      />
      <TextField
        label="Notes"
        value={packageToUpdate?.notes ?? ''}
        onChange={e => setPackageToUpdate(p => p ? { ...p, notes: e.target.value } : p)}
        fullWidth
        margin="dense"
      />

    <TextField
      label="Ad Space IDs (JSON array)"
      value={adSpacesInput}
      onChange={e => setAdSpacesInput(e.target.value)}
      onBlur={handleAdSpacesInputSave}
      fullWidth
      margin="dense"
      helperText='Enter a JSON array, e.g. [1, 2, 3]'
    />

      <FormControl fullWidth margin="dense">
        <InputLabel id="active-label">Active</InputLabel>
        <Select
          labelId="active-label"
          value={packageToUpdate?.active !== undefined ? (packageToUpdate.active ? 'yes' : 'no') : 'yes'}
          label="Active"
          onChange={e => setPackageToUpdate(p => p ? { ...p, active: e.target.value === 'yes' } : p)}
        >
          <MenuItem value="yes">Yes</MenuItem>
          <MenuItem value="no">No</MenuItem>
        </Select>
      </FormControl>
      
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button color="primary" onClick={onSave}>Save</Button>
    </DialogActions>
  </Dialog>
);
};